import type { AnimationConnection, AnimationGraphNode } from "@/document/model/animation";
import type { VectorEdge, VectorRegion, VectorVertex } from "@/document/model/vectorNetwork";
import {
  DEFAULT_DUPLICATE_OFFSET,
  type CurvaClipboardPayload,
  type CurvaStyleClipboardPayload,
} from "@/editor/shell/shellTransfer";
import type { Rect } from "@/lib/math/rect";

export type VectorSelectionClipboard = {
  nodeId: string;
  vertices: VectorVertex[];
  edges: VectorEdge[];
  regions: VectorRegion[];
  bounds: Rect;
};

export class ClipboardStore {
  localClipboard: CurvaClipboardPayload | undefined;
  localStyleClipboard: CurvaStyleClipboardPayload | undefined;
  localVectorClipboard: VectorSelectionClipboard | undefined;
  animationClipboard: { nodes: AnimationGraphNode[]; connections: AnimationConnection[] } | undefined;
  imagePasteHandledAt = 0;
  lastDuplicateOffset = { ...DEFAULT_DUPLICATE_OFFSET };
  duplicateContinuationSourceNodeIds: string[] | undefined;

  clearObjectClipboards = (): void => {
    this.localClipboard = undefined;
    this.localStyleClipboard = undefined;
    this.localVectorClipboard = undefined;
  };

  resetDuplicateContinuation = (): void => {
    this.lastDuplicateOffset = { ...DEFAULT_DUPLICATE_OFFSET };
    this.duplicateContinuationSourceNodeIds = undefined;
  };

  clearAll = (): void => {
    this.clearObjectClipboards();
    this.animationClipboard = undefined;
    this.resetDuplicateContinuation();
    this.imagePasteHandledAt = 0;
  };

  markImagePasteHandled = (): void => {
    this.imagePasteHandledAt = performance.now();
  };

  hasAnimationClipboard = (): boolean => {
    return Boolean(this.animationClipboard && this.animationClipboard.nodes.length > 0);
  };
}

export const clipboardStore = new ClipboardStore();
